// Copyright (c) 2016 Deere & Company

import './additional-status-item.scss';
import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

const StatusItem = ({status}) =>
    <div className='status-item'>{status.value}</div>;

StatusItem.displayName = 'StatusItem';
StatusItem.propTypes = {
    status: PropTypes.instanceOf(KeyValuePair).isRequired
};

export default StatusItem;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/product-info-view/additional-status-item.js